import styled from '@emotion/styled';

import {
  animation,
  border,
  breakpoints,
  colors,
  fontWeight,
} from '@datacamp/waffles-tokens';

export const A = styled.a`
  color: ${colors.grey};
  display: block;
  font-weight: ${fontWeight.regular};
  margin-bottom: 4px;
  padding: 4px 0;
  transition: opacity ${animation.transition};

  &:active,
  &:focus,
  &:hover {
    color: ${colors.greyDark};
    border-color: transparent;
  }
`;

export const Backdrop = styled.div`
  background-color: ${colors.primaryDarker};
  bottom: 0;
  display: ${props => (props.isHidden ? 'none' : 'block')};
  left: 0;
  opacity: 0.8;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 80;

  &.isHidden {
    display: none;
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: 0;
  position: absolute;
  right: 0;
  top: 12px;

  .icon {
    color: ${colors.primary};
  }
`;

export const Container = styled.nav`
  background-color: ${colors.white};
  border-radius: ${border.radius};
  box-shadow: 0 15px 65px rgba(0, 0, 0, 0.5);
  display: block;
  max-width: 320px;
  position: absolute;
  right: 16px;
  text-align: left;
  top: 20px;
  z-index: 90;

  @media screen and (min-width: 352px) {
    width: 320px;
  }
`;

export const FooterLink = styled.a`
  background: ${colors.primaryLightest};
  border-radius: 0 0 ${border.radius} ${border.radius};
  color: ${colors.greyDark};
  display: block;
  padding: 16px;
  text-align: center;
  transition: ${animation.transition};

  &:active,
  &:focus,
  &:hover {
    color: ${colors.primary};
  }
`;

export const Logo = styled.a``;

export const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const ListItem = styled.li`
  a:last-of-type {
    margin-bottom: 0;
  }
`;

export const MenuButton = styled.button`
  background: none;
  border: 0;
  margin-right: -8px; /* counter icon artboard */
  padding: 0;

  @media screen and (min-width: ${breakpoints.md}) {
    display: none; /* Not necessary if the component is removed */
  }
`;

export const Plans = styled.h5`
  margin-top: 16px;
`;

export const Section = styled.section`
  border-top: 1px solid ${colors.greyLighter};
  padding: 16px;

  &:first-of-type {
    border-top: 0;
  }
`;

export const Wrapper = styled.div`
  bottom: 0;
  left: 0;
  position: fixed;
  padding-top: 4px;
  right: 0;
  top: 0;
  z-index: 70;

  &.isHidden {
    display: none;
  }
`;
